import { Component } from '@contorion/core';

export class OpenDixaChatComponent extends Component {
    constructor(public element: Element) {
        super(element);
        this.element.addEventListener('click', this.clickAction.bind(this));
    }
    protected clickAction(): void {
        if(window._dixa_) {
           window._dixa_.invoke('setWidgetOpen', true);
        }
    }
}
